import {memo} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/utils';
import {body16Normal, headingS, headingXS} from '~/shared/theme/typography';
import {flexColumn} from '~/shared/theme/FlexLayout';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import PieButton from '~/shared/theme/pie/PieButton';
import {selectCurrentRestaurant} from '~/shared/store/selectors';

import illustrationImg from './assets/missing-item.png';

const Root = styled.div`
  ${flexColumn}
  align-items: center;
  justify-content: center;
  padding: 0 16px 32px;
  height: 100%;
  width: 100%;

  &&& {
    background-color: ${({theme}) => theme.colors.surface};
  }

  ${media.minLargeMobile`
    padding: 0 32px 24px;
    &&& {
      width: 500px;
    }
  `}
`;

const Illustration = styled(ImageWithAlt).attrs({
  src: illustrationImg,
  noAlt: true,
})`
  width: 150px;
  height: 150px;
  ${media.minLargeMobile`
    width: 200px;
    height: 200px;
    margin-top: 88px;
  `}
`;

const TextWrapper = styled.div`
  ${flexColumn}
  align-items: center;
  text-align: center;
  gap: 8px;
  margin-top: 24px;
  width: 100%;
  color: ${({theme}) => theme.colors.charcoal80};
`;

const Title = styled.h2`
  ${headingXS}
  ${media.minLargeMobile`
    ${headingS}
  `}
`;

const SubTitle = styled.p`
  ${body16Normal}
  line-height: 24px;
`;

const ActionButton = styled(PieButton)`
  width: 100%;
  margin-top: 32px;
`;

const DishNotFound = ({onClose}: {onClose: () => void}) => {
  const {t} = getLocalizationService();
  const currentRestaurant = useSelector(selectCurrentRestaurant);

  const isRestaurant = currentRestaurant?.businessType === 'Restaurant';
  
  return (
    <Root>
      <Illustration />
      <TextWrapper>
        <Title id="modal-title">{t(isRestaurant ? 'dish_not_found_title' : 'item_not_found_title')}</Title>
        <SubTitle>{t(isRestaurant ? 'dish_not_found_subtitle' : 'item_not_found_subtitle')}</SubTitle>
      </TextWrapper>
      <ActionButton variant="primaryLarge" onClick={onClose}>{t(isRestaurant ? 'dish_not_found_action' : 'item_not_found_action')}</ActionButton>
    </Root>
  );
};

export default memo(DishNotFound);
